// --------------------------------------------------------------------------
// sponsors.js
// --------------------------------------------------------------------------

RN.sponsors = function() {

  'use strict';

  var stickyAlert;

  function init() {
    var items = byBehaviour('sponsors').find('img');
    var length = items.length;
    var index = 0;

    $(items[index]).fadeIn();
    setInterval(function(){
      $(items[index%length]).fadeOut(function(){
        ++index;
        $(items[index%length]).fadeIn();
      });
    }, 3000);
  }

  return {
    init: init
  };

}();